// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WithdrawMoney.css */

.tab-container {
    margin-bottom: 20px;
    padding: 0;
}

.nav-tabs {
    border-bottom: 2px solid #4E3B31;
    margin-bottom: 0;
    /* Ensure no extra margin below tabs */
}

.nav-tabs .nav-item {
    margin-bottom: 0;
    /* Align tabs with content */
}

.nav-tabs .nav-link {
    border: 1px solid transparent;
    border-radius: .25rem .25rem 0 0;
    padding: 10px 20px;
    margin-right: 0;
    /* No margin between tabs */
    font-weight: 500;
    color: #4E3B31;
    background-color: #f8f9fa;
    transition: background-color 0.3s, color 0.3s;
}

.nav-tabs .nav-link.active {
    color: #fff;
    background-color: #4E3B31;
    border-color: #4E3B31;
}

.tab-content {
    border-radius: .25rem;
    background-color: #fff;
    padding: 1rem;
    margin-top: -1px;
    /* Overlap tab border to ensure content aligns */
}

.table {
    margin: 0;
    border-collapse: collapse;
}

.table-bordered {
    border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
    border: 1px solid #dee2e6;
    padding: 0.75rem;
    vertical-align: top;
}

.table thead th {
    background-color: #4E3B31;
    color: white;
    font-weight: bold;
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}

.btn-primary {
    background-color: #4E3B31;
    border-color: #4E3B31;
}

.btn-primary:hover {
    background-color: #4E3B31;
    border-color: #4E3B31;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.alert-info {
    background-color: #e7f0ff;
    border-color: #b6d4fe;
}

.table-container {
    overflow-x: auto;
    margin-bottom: 20px;
}

.table {
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
}

.table th, .table td {
    text-align: center;
    padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/style/WithdrawMoney.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":["/* WithdrawMoney.css */\r\n\r\n.tab-container {\r\n    margin-bottom: 20px;\r\n    padding: 0;\r\n}\r\n\r\n.nav-tabs {\r\n    border-bottom: 2px solid #4E3B31;\r\n    margin-bottom: 0;\r\n    /* Ensure no extra margin below tabs */\r\n}\r\n\r\n.nav-tabs .nav-item {\r\n    margin-bottom: 0;\r\n    /* Align tabs with content */\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n    border: 1px solid transparent;\r\n    border-radius: .25rem .25rem 0 0;\r\n    padding: 10px 20px;\r\n    margin-right: 0;\r\n    /* No margin between tabs */\r\n    font-weight: 500;\r\n    color: #4E3B31;\r\n    background-color: #f8f9fa;\r\n    transition: background-color 0.3s, color 0.3s;\r\n}\r\n\r\n.nav-tabs .nav-link.active {\r\n    color: #fff;\r\n    background-color: #4E3B31;\r\n    border-color: #4E3B31;\r\n}\r\n\r\n.tab-content {\r\n    border-radius: .25rem;\r\n    background-color: #fff;\r\n    padding: 1rem;\r\n    margin-top: -1px;\r\n    /* Overlap tab border to ensure content aligns */\r\n}\r\n\r\n.table {\r\n    margin: 0;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.table-bordered {\r\n    border: 1px solid #dee2e6;\r\n}\r\n\r\n.table-bordered th,\r\n.table-bordered td {\r\n    border: 1px solid #dee2e6;\r\n    padding: 0.75rem;\r\n    vertical-align: top;\r\n}\r\n\r\n.table thead th {\r\n    background-color: #4E3B31;\r\n    color: white;\r\n    font-weight: bold;\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.btn-primary {\r\n    background-color: #4E3B31;\r\n    border-color: #4E3B31;\r\n}\r\n\r\n.btn-primary:hover {\r\n    background-color: #4E3B31;\r\n    border-color: #4E3B31;\r\n}\r\n\r\n.loading-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n}\r\n\r\n.alert-info {\r\n    background-color: #e7f0ff;\r\n    border-color: #b6d4fe;\r\n}\r\n\r\n.table-container {\r\n    overflow-x: auto;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.table {\r\n    width: 100%;\r\n    table-layout: auto;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.table th, .table td {\r\n    text-align: center;\r\n    padding: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
